import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { Routes } from './Routes';
import { AuthProvider } from './components_auth/AuthContext';
import BasicSkipToButton from './components_skipto/BasicSkipToButton';
import { initializeCollaborationBrowserIntegration } from './collaboration/services/browserIntegration';

// Initialize collaboration browser integration (cleanup & debug helpers)
initializeCollaborationBrowserIntegration();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <AuthProvider>
      <BasicSkipToButton />
      <Routes />
    </AuthProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
